<template>
    <el-card shadow="hover">
        <label slot="header">JEllipsis缩略详情</label>
        <el-divider content-position="left">单独使用</el-divider>
        <div style="width: 200px">
            <j-ellipsis>
                <div v-for="index in 10" :key="index" :title="index">分割{{index}}</div>
            </j-ellipsis>
        </div>
        <el-divider content-position="left">表格中使用</el-divider>
        <el-table
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column prop="hover触发(默认，号分割)" label="行政区划" width="630px">
                <j-ellipsis trigger="hover" separator="," >
                    <span v-for="index in 10" :key="index" :title="index">宜昌市 - 枝江市 - 董市镇 - 马家冲村 - 马家冲村{{index}}网格</span>
                </j-ellipsis>
            </el-table-column>
            <el-table-column prop="click触发" label="标签div(#号分割)" width="200px">
                <j-ellipsis trigger="click" separator="#">
                    <div>标签1</div>
                    <div>标签2</div>
                    <div>标签3</div>
                    <div>标签4</div>
                </j-ellipsis>
            </el-table-column>
            <el-table-column prop="num" label="默认3以上时出现详情省略" width="200px">
                <j-ellipsis slot-scope="{row}" separator=",">
                    <span v-for="index in row.num" :key="index" :title="index">杰{{index}}</span>
                </j-ellipsis>
            </el-table-column>
        </el-table>
    </el-card>
</template>

<script>
    import JEllipsis from "./JEllipsis";
    export default {
        name: "JEllipsisDemo",
        components: {
            JEllipsis
        },
        data() {
            return {
                tableData: [
                    { num: 1 },
                    { num: 3 },
                    { num: 10 }
                ]
            }
        }
    }
</script>
